import { t } from "ttag";

import { AuthButton } from "metabase/auth/components/AuthButton";

interface AtkvButtonProps {
  redirectUrl?: string;
  isCard?: boolean;
}

// ATKV (Logto) OIDC login button. Performs a full-page navigation to the backend
// `/auth/oidc/login` endpoint, which kicks off the server-side OIDC flow.
export const AtkvButton = ({
  redirectUrl,
  isCard,
}: AtkvButtonProps): JSX.Element => {
  const handleLogin = () => {
    const base = "/auth/oidc/login";
    const url = redirectUrl
      ? `${base}?redirect=${encodeURIComponent(redirectUrl)}`
      : base;
    window.location.assign(url);
  };

  return (
    <AuthButton isCard={isCard} onClick={handleLogin}>
      {t`Sign in with ATKV`}
    </AuthButton>
  );
};
